import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { push } from "../../utils/navigation";
import { withRouter } from "../../utils/withRouter";
import {
  listClientLocations,
  saveUrgentTankSwapRequest,
} from "../../actions/homeActions";
import {allowUserWithRoles, BASE_URL, ROLE_OfficeUser, ROLE_SalesManager, ROLE_SuperUser} from "../../constants";
import {
  isTankExpectedVolumeMet,
  mustBeArray,
  requestHasError,
} from "../../utils";
import { apiRequest } from "../../utils/request";
import UrgentRequestConfirmationModal from "../Common/UrgentLocationConfirmationModal";
import UrgetnRequestUploadsAndNotes from "../Common/UrgentRequestUploadsAndNotes";
import TankSwapList from "./TankSwapList";

const UrgentCollectionRequest = ({ dispatch, siteConfig, locationId, account }) => {
  const [notes, setNotes] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedTank, setSelectedTank] = useState(null);
  const [conditionAgreed, setConditionAgreed] = useState(false);
  const [switchedSelectedTank, setSwitchedSelectedTank] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [tanks, setTanks] = useState([]);
  const [tanksLoading, setTanksLoading] = useState(false);

  useEffect(() => {
    dispatch(listClientLocations("Collection", locationId));
    fetchTanksList(locationId);
  }, []);

  const fetchTanksList = (locationId = null) => {
    setTanksLoading(true);
    apiRequest(`/api/clientrequests/location-tanks?locationId=${locationId}`).then((x) => {
      setTanks(mustBeArray(x && x.data && x.data.locationTanks));
      setTanksLoading(false);
    });
  };

  const handleFileDelete = ({ image, index }) => {
    let tempFileCollection = [...files];
    tempFileCollection.splice(index, 1);
    setFiles(tempFileCollection);
  };

  const handleFileChange = (fileList) => {
    setFiles([...files, ...fileList]);
  };

  const handleNoteChange = (e) => {
    setNotes(e.currentTarget.value);
  };

  const handleSave = () => {
    if (!selectedTank) {
      return toastr.error("Please select a tank.");
    }
    if (!conditionAgreed) {
      return toastr.error("Please accept terms and conditions.");
    }
    const isOfficeOrSuperUser = allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager]);

    if (!isOfficeOrSuperUser && _.isEmpty(files)) {
      return toastr.error("Please upload images.");
    }
    
    const tank = mustBeArray(tanks).find((o) => o.tankId === selectedTank);
    setSubmitLoading(true);
    let payLoad = {
      additionalInformation: notes,
      attachments: files,
      tankId: selectedTank,
      locationId: tank && tank.locationId,
    };
    dispatch(saveUrgentTankSwapRequest({ payLoad })).then((x) => {
      setSubmitLoading(false);
      if (!requestHasError({ x })) {
        toastr.success("Tank swap request created.");
        dispatch(push(`${BASE_URL}/client-requests`));
      }
    });
  };

  const handleSelection = (id) => {
    if (selectedTank && id !== selectedTank) {
      // show confirmation modal
      setSwitchedSelectedTank(id);
      setViewModal(true);
    } else {
      setSelectedTank(id);
      if (
        isTankExpectedVolumeMet({
          tanks,
          selectedTank: id,
          vacuumMonths: siteConfig && siteConfig.vacuumMonths,
          standardMonths: siteConfig && siteConfig.standardMonths,
          litres: siteConfig && siteConfig.litres,
        })
      ) {
        setConditionAgreed(true);
      }
    }
  };

  const handleTermsAgreementChange = () => {
    setConditionAgreed(!conditionAgreed);
  };

  const handleModalClose = () => {
    setViewModal(false);
    setSwitchedSelectedTank(null);
  };

  const handleUpdateSelectedTank = () => {
    setSelectedTank(switchedSelectedTank);
    setSwitchedSelectedTank(null);
    setViewModal(false);
    setConditionAgreed(
      isTankExpectedVolumeMet({
        tanks,
        selectedTank: switchedSelectedTank,
        vacuumMonths: siteConfig && siteConfig.vacuumMonths,
        standardMonths: siteConfig && siteConfig.standardMonths,
        litres: siteConfig && siteConfig.litres,
      })
    );
    setFiles([]);
  };

  return (
    <React.Fragment>
      <div className={"row"}>
        <div className={"col-12"} style={{ marginBottom: "24px" }}>
          <h4>Request Tank Swap or Repair</h4>
        </div>
      </div>
      <TankSwapList
        tanks={tanks}
        handleSelection={handleSelection}
        selectedTank={selectedTank}
        handleTermsAgreementChange={handleTermsAgreementChange}
        conditionAgreed={conditionAgreed}
        expectedVolumeMet={isTankExpectedVolumeMet({
          tanks,
          selectedTank,
          vacuumMonths: siteConfig && siteConfig.vacuumMonths,
          standardMonths: siteConfig && siteConfig.standardMonths,
          litres: siteConfig && siteConfig.litres,
        })}
        tanksLoading={tanksLoading}
      />
      {conditionAgreed && (
        <UrgetnRequestUploadsAndNotes
          handleFileChange={handleFileChange}
          handleFileDelete={handleFileDelete}
          handleNoteChange={handleNoteChange}
          files={files}
          notes={notes}
        />
      )}

      <button
        className={`btn btn-success mobile-full-width mobile-screen-button mb-1 float-right ${
          submitLoading ? "no-pointer-events" : ""
        }`}
        onClick={handleSave}
      >
        {submitLoading ? "Requesting" : "Request Tank Swap/Repair"}
      </button>
      <UrgentRequestConfirmationModal
        visible={viewModal}
        handleUpdateSelectedCollection={handleUpdateSelectedTank}
        handleModalClose={handleModalClose}
        type="tank"
      />
    </React.Fragment>
  );
};

function mapStateToProps(state, ownProps) {
  const locationId = parseInt(ownProps.routeParams.locationId);
  return {
    siteConfig: state.apiConfig,
    account: state.account,
    locationId: isNaN(locationId) ? null : locationId,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UrgentCollectionRequest));
